import { useContext, useEffect, useState } from 'react'
import AppTable from '../table/AppTable';
import { useLazyQuery } from '@apollo/client';
import { GET_DELIST_AND_RETURN_TICKETS, GET_DELIST_AND_RETURN_TICKETS_BY_LOGITIXUSER, GET_LIST_TICKETS, GET_LIST_TICKETS_BY_LOGITIXUSER } from '../../../features/Tickets/api/TicketsQuery';
import { globalContext } from '../../../Provider/AppProvider';
import { CircularProgress } from '@mui/material';
import ToasterWithMessage from '../toaster';
import styles from '../../../features/Users/Users.module.css'
import { roles } from '../../../helper';

const DelistAndReturnTickets = (props: any) => {
  const {
  rowsPerPage,
  currentPage,
  setCurrentPage, 
  checking,
  setChecking, 
  delistAndReturnTicketList,
  setDelistAndReturnTicketList,
  selected,
  setSelected,
  columnTypes,
  setColumnTypes,
  sortType,
  setSortType,
  GenerateDelistAndReturnTicketHeadCells,
  handleChangeRowsPerPage,
  handlePageChange,
  activeTab
  } = props;

  const {globalState,handleGlobalState} = useContext<any>(globalContext);
  const [searchvalue, setSearchvalue] = useState(globalState?.globalSearch?.searchtext);
  const {error} = ToasterWithMessage();

  const [getDelistAndReturnTickets, {loading}] = useLazyQuery(GET_DELIST_AND_RETURN_TICKETS,{
    fetchPolicy: 'no-cache',
    onCompleted: (delistAndReturnTicketData) => {
        setDelistAndReturnTicketList(delistAndReturnTicketData);
        const tempState = {...globalState};
        tempState.delistAndReturnTicketFilter.clicked = false;
        if(globalState.notification.notificationClicked){
        tempState.manageTicketFilter.notificationFilterDataCount = delistAndReturnTicketData?.filtermanagetickets_aggregate?.aggregate?.count;
        tempState.listTicketFilter.notificationFilterDataCount = delistAndReturnTicketData?.filterlisttickets_aggregate?.aggregate?.count;
        tempState.soldTicketFilter.notificationFilterDataCount = delistAndReturnTicketData?.FilterSoldTickets_aggregate?.aggregate?.count;
        tempState.delistAndReturnTicketFilter.notificationFilterDataCount = delistAndReturnTicketData?.filterreturntickets_aggregate?.aggregate?.count;
        tempState.unsoldTicketFilter.notificationFilterDataCount = delistAndReturnTicketData?.filterUnsoldTickets?.aggregate?.count;
      }if(globalState.error.errorClicked){  
        tempState.manageTicketFilter.errorFilterDataCount = delistAndReturnTicketData?.filtermanagetickets_aggregate?.aggregate?.count;
        tempState.listTicketFilter.errorFilterDataCount = delistAndReturnTicketData?.filterlisttickets_aggregate?.aggregate?.count;
        tempState.soldTicketFilter.errorFilterDataCount =delistAndReturnTicketData?.FilterSoldTickets_aggregate?.aggregate?.count;  
        tempState.delistAndReturnTicketFilter.errorFilterDataCount = delistAndReturnTicketData?.filterreturntickets_aggregate?.aggregate?.count;
        tempState.unsoldTicketFilter.errorFilterDataCount = delistAndReturnTicketData?.filterUnsoldTickets?.aggregate?.count;
        tempState.delistAndReturnTicketFilter.clicked = false;
      }
        handleGlobalState(tempState);
    },
    onError: () => {
        error("We’re having trouble connecting. Please clear your cache, refresh the page, and try again.");
    }
  })
  
  const [getDelistAndReturnTicketsByLogitix, {loading:logitixLoading}] = useLazyQuery(GET_DELIST_AND_RETURN_TICKETS_BY_LOGITIXUSER,{
    fetchPolicy: 'no-cache',
    onCompleted: (delistAndReturnTicketDataForLogitix) => {
        setDelistAndReturnTicketList(delistAndReturnTicketDataForLogitix);
        const tempState = {...globalState};
        tempState.delistAndReturnTicketFilter.clicked = false;
        if(globalState.notification.notificationClicked){
        tempState.manageTicketFilter.notificationFilterDataCount = delistAndReturnTicketDataForLogitix?.filtermanagetickets_aggregate?.aggregate?.count;
        tempState.listTicketFilter.notificationFilterDataCount = delistAndReturnTicketDataForLogitix?.filterlisttickets_aggregate?.aggregate?.count;
        tempState.soldTicketFilter.notificationFilterDataCount = delistAndReturnTicketDataForLogitix?.FilterSoldTickets_aggregate?.aggregate?.count;
        tempState.delistAndReturnTicketFilter.notificationFilterDataCount = delistAndReturnTicketDataForLogitix?.filterreturntickets_aggregate?.aggregate?.count;
        tempState.unsoldTicketFilter.notificationFilterDataCount = delistAndReturnTicketDataForLogitix?.filterUnsoldTickets_aggreagate?.aggregate?.count;
      }if(globalState.error.errorClicked){  
        tempState.manageTicketFilter.errorFilterDataCount = delistAndReturnTicketDataForLogitix?.filtermanagetickets_aggregate?.aggregate?.count;
        tempState.listTicketFilter.errorFilterDataCount = delistAndReturnTicketDataForLogitix?.filterlisttickets_aggregate?.aggregate?.count;
        tempState.soldTicketFilter.errorFilterDataCount =delistAndReturnTicketDataForLogitix?.FilterSoldTickets_aggregate?.aggregate?.count;  
        tempState.delistAndReturnTicketFilter.errorFilterDataCount = delistAndReturnTicketDataForLogitix?.filterreturntickets_aggregate?.aggregate?.count;
        tempState.unsoldTicketFilter.errorFilterDataCount = delistAndReturnTicketDataForLogitix?.filterUnsoldTickets_aggreagate?.aggregate?.count;
        tempState.delistAndReturnTicketFilter.clicked = false;
      }
        handleGlobalState(tempState);
    },
    onError: () => {
        error("We’re having trouble connecting. Please clear your cache, refresh the page, and try again.");
    }
  })

  useEffect(() => {
    const tempdata = {...globalState}
    setSearchvalue(tempdata?.globalSearch?.searchtext)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalState?.globalSearch?.searchtext]);

  useEffect(() => {
    const delistAndReturnTicketsVariables={
      leagueId: globalState?.delistAndReturnTicketFilter?.leagueId,
      ticketStatus: globalState?.delistAndReturnTicketFilter?.ticketStatus,
       startdate:globalState?.delistAndReturnTicketFilter?.startdate ? globalState?.delistAndReturnTicketFilter?.startdate : globalState?.delistAndReturnTicketFilter?.startDateRange,
       enddate:globalState?.delistAndReturnTicketFilter?.enddate ? globalState?.delistAndReturnTicketFilter?.enddate : globalState?.delistAndReturnTicketFilter?.endDateRange,
       pageSize: rowsPerPage,
       pageOffset: (currentPage -1)*rowsPerPage,
       order_by: [{[columnTypes]: sortType},{"tp_id": "asc"}],
       search_event:searchvalue === globalState.notification.text ?"%":searchvalue === globalState.error.text ?"%":`${searchvalue}%`,
       ticketId:globalState.notification.ticketId,
       ticketPlacementId: globalState.notification.tpId,
       array_tpid: globalState?.notification.tp_id_array?globalState?.notification.tp_id_array:globalState?.error?.approximateTpArray?.length > 0  ? globalState.error.approximateTpArray : globalState.error.ticketPlacementId
      };

    if((globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN)){
    getDelistAndReturnTickets({
      variables: delistAndReturnTicketsVariables
    })
  }else{
    getDelistAndReturnTicketsByLogitix({
      variables: delistAndReturnTicketsVariables
    })
  }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalState?.globalSearch?.searchtext,searchvalue,globalState.notification.notificationSearchCancel]);

useEffect(()=>{
  if((activeTab === 3)){
    const ticketsVariables= {
      leagueId:  globalState?.notification?.notificationClicked ? null: globalState?.error?.errorClicked? null : globalState?.delistAndReturnTicketFilter?.leagueId,
      ticketStatus:  globalState?.notification?.notificationClicked ? null: globalState?.error?.errorClicked ? null : globalState?.delistAndReturnTicketFilter?.ticketStatus,
       startdate:  globalState?.notification?.notificationClicked ? null:globalState?.error?.errorClicked? null : globalState?.delistAndReturnTicketFilter?.startdate ? globalState?.delistAndReturnTicketFilter?.startdate : globalState?.delistAndReturnTicketFilter?.startDateRange,
       enddate:  globalState?.notification?.notificationClicked ? null:globalState?.error?.errorClicked? null : globalState?.delistAndReturnTicketFilter?.enddate ? globalState?.delistAndReturnTicketFilter?.enddate : globalState?.delistAndReturnTicketFilter?.endDateRange,
       pageSize: rowsPerPage,
       pageOffset: (currentPage -1)*rowsPerPage,
       order_by: [{[columnTypes]: sortType},{"tp_id": "asc"}],
       search_event:searchvalue === globalState.notification.text ?"%":searchvalue === globalState.error.text ?"%":`${searchvalue}%`,
       ticketId:globalState.notification.ticketId,
       ticketPlacementId: globalState.notification.tpId,
       array_tpid: globalState?.notification.tp_id_array?globalState?.notification.tp_id_array:globalState?.error?.approximateTpArray?.length > 0  ? globalState.error.approximateTpArray : globalState.error.ticketPlacementId
      };

    if((globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN)){
    getDelistAndReturnTickets({
      variables:ticketsVariables
    })
  }else{
    getDelistAndReturnTicketsByLogitix({
      variables: ticketsVariables
    })
  }
  }

// eslint-disable-next-line react-hooks/exhaustive-deps
},[activeTab,
  getDelistAndReturnTickets,
  rowsPerPage,
  currentPage,
  sortType,
  columnTypes,
  searchvalue,
]);

useEffect(()=>{
  if(globalState.delistAndReturnTicketFilter.clicked){
    const getDelistAndReturnTicketsVariables={
      leagueId: globalState?.delistAndReturnTicketFilter?.leagueId,
      ticketStatus: globalState?.delistAndReturnTicketFilter?.ticketStatus,
       startdate:globalState?.delistAndReturnTicketFilter?.startdate ? globalState?.delistAndReturnTicketFilter?.startdate : globalState?.delistAndReturnTicketFilter?.startDateRange,
       enddate:globalState?.delistAndReturnTicketFilter?.enddate ? globalState?.delistAndReturnTicketFilter?.enddate : globalState?.delistAndReturnTicketFilter?.endDateRange,
       pageSize: rowsPerPage,
       pageOffset: (currentPage -1)*rowsPerPage,
       order_by: [{[columnTypes]: sortType},{"tp_id": "asc"}],
       search_event: `${searchvalue}%`,
       ticketId:globalState.notification.ticketId,
       ticketPlacementId: globalState.notification.tpId,
       array_tpid: globalState?.notification.tp_id_array?globalState?.notification.tp_id_array:globalState?.error?.approximateTpArray?.length > 0  ? globalState.error.approximateTpArray : globalState.error.ticketPlacementId
      };

    if((globalState.profile.userRole===roles.ADMIN || globalState.profile.userRole===roles.AFFILIATER_ADMIN)){
    getDelistAndReturnTickets({
      variables: getDelistAndReturnTicketsVariables
    });
  }else{
    getDelistAndReturnTicketsByLogitix({
      variables: getDelistAndReturnTicketsVariables
    });
  }
  }

// eslint-disable-next-line react-hooks/exhaustive-deps
},[
  getDelistAndReturnTickets,
  globalState.delistAndReturnTicketFilter.clicked
]);

  return (
    <>
      {
        (loading || logitixLoading )
      ?   <div className={styles.TableCircularProgress}>
          <CircularProgress color="primary" size={35} />
          </div>
      :
         <AppTable
           handleChangeRowsPerPage={handleChangeRowsPerPage}
           handlePageChange={handlePageChange}
           setColumnTypes = {setColumnTypes}
           sortType = {sortType}
           setSortType = {setSortType}
           setSelected = {setSelected}
           setChecking = {setChecking}
           checking = {checking}
           selected ={selected}
           rowsPerPage = {rowsPerPage}
           setCurrentPage={setCurrentPage}
           currentPage= {currentPage}
           list={delistAndReturnTicketList}
           tableTitle = "delistAndReturnTickets"
           generateHeadCells = {GenerateDelistAndReturnTicketHeadCells}
         />
      }
    </>
  );
}

export default DelistAndReturnTickets
